import React from 'react';
import { IconCalendarMonth, IconHome } from '@tabler/icons-react';

import Sidebar from './Sidebar';
import { ModuleLink } from './SidebarItem';

const moduleLinks: ModuleLink[] = [
    {
        label: 'Home',
        icon: IconHome,
        path: '',
    },
    {
        label: 'Calendar',
        icon: IconCalendarMonth,
        path: 'calendar',
    },
];

function StandInManagementSidebar() {
    return (
        <Sidebar moduleLinks={moduleLinks} pathPrefix="/stand-in-management/" />
    );
}

export default StandInManagementSidebar;
